import { MtxGridColumn } from '@ng-matero/extensions/grid';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ITableFilterConfig } from '../table-base/table-base.types';

export interface IDialogData {
  columns: MtxGridColumn[];
  filterFields: FormlyFieldConfig[];
  filterValues: ITableFilterConfig;
  actions: {
    onSubmit: (formModel) => void;
    onReset: () => void;
  };
}

export const DEFAULT_TABLE_CONFIG: ITableConfig = <ITableConfig>{
  showToolbar: true,
  showColumnMenu: true,
  columnResizable: false,
  pageOnFront: true,
  pageIndex: 0,
  pageSize: 10,
  pageSizeOptions: [5, 10, 20, 50, 100],
  showPaginator: true,
  filterOnFront: true,
  sortOnFront: true,
  filterOptions: {},
  rowSelectable: false,
  multiSelectable: false,
  expandable: false,
  hidePageSize: false,
};

export interface ITableData {
  items: unknown[];
  itemsOriginal: unknown[];
  totalCount: number;
}

export interface ITableConfig {
  showToolbar: boolean;
  showColumnMenu: boolean;
  columnResizable: boolean;
  sortOnFront: boolean;
  filterOnFront: boolean;
  filterFields?: FormlyFieldConfig[];
  filterOptions: any;
  pageOnFront: boolean;
  pageIndex: number;
  pageSize: number;
  pageSizeOptions: number[];
  hidePageSize: boolean;
  showPaginator: boolean;
  rowSelectable: boolean;
  multiSelectable: boolean;
  expandable: boolean;
}
